import styled from "styled-components";

const FooterMainFlowerStyled = styled.footer`
  .footer-wrap {
    ${({simple, theme: { colors }}) => simple ? "" : "background-color: " + colors.brandLight};
    display: flex;
    background-image: url("../../images/Footer_Image.jpg");
    background-origin: padding-box;
    background-repeat: no-repeat;
    flex-direction: column;
    align-items: center;
    padding: 30px 0;

    @media (max-width: 599px) {
      padding: 0 3.5rem 1rem 3.5rem;
      min-height: 438px;
      justify-content: center;
      background-size: 100% 100%;
      background-image: url("../../images/HOF_Footer_Image_Mobile.jpg");
    }
    @media (min-width: 600px) {
      padding: 64px 32px;
      min-height: 35vh;
      background-size: 100% 100%;
    }
  }

  .footer-home__heading {
    margin-top: 2.5rem;
    color: ${({theme}) => theme.colors.brandDark};
  }
  
  .footer-home__logo {
    margin: 0 0 3rem 3rem;
    width: 151px;
    height: 137px;
    @media (max-width: 859px) {
      width: 110px;
      height: 120px;
      margin: 0 0 .5rem 0;
    }
  }

  .footer-home__links {
    width: 100%;
    
    @media (max-width: 599px) {
      //grid-template-columns: repeat(2, 1fr);
    }
    @media (min-width: 600px) and (max-width: 859px) {
      grid-template-columns: repeat(3, 1fr);
    }
    @media (max-width: 859px) {
      display: grid;
      //grid-gap: 20px 16px;
      justify-content: center;
    }
    @media (min-width: 860px) {
      max-width: 800px;
      display: flex;
      justify-content: space-between;
    }
  }

  .footer-home__link {
    a {
      color: ${({theme}) => theme.colors.brandDark};

      &:hover,
      &:focus {
        text-decoration: underline;
      }

      @media (min-width: 860px) {
        padding-top: 1rem;
        padding-bottom: 1rem;
      }
    }
    @media (max-width: 859px) {
      text-align: center;
    }
    
    @media (min-width: 860px) {
      display: inline-flex;

      &:not(:last-of-type) {
        margin-right: 40px;
      }
    }
  }

  .footer-home__socials {
    padding-right: 32px;
    padding-left: 32px;
    display: flex;
    width: 100%;
    max-width: 900px;
    justify-content: center;
  }

  .footer-home__social {
    display: inline-flex;
    
    a {
      padding: 16px;
      display: flex;
    }

    svg {
      width: 24px;
      height: 24px;
      display: flex;
      flex-shrink: 0;
      fill: ${({theme}) => theme.colors.brandDark};
      transition: var(--button-transition);
    }

    &:hover,
    &:focus {
      svg {
        fill: ${({theme}) => theme.colors.brand}
      }
    }
  }

  .footer-home__affiliate,
  .footer-home__copywrite {
    color: ${({theme}) => theme.colors.brandDark};
    text-align: center;
    margin-top: .5rem;
    @media (min-width: 860px) {
      text-align: center;
    }
  }

  .footer-home__affiliate {
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }

  .footer-home__license {
    margin-top: 0.5rem;
    color: ${({theme}) => theme.colors.brandDark};
    text-align: center;
  }

  .test-logo {
    font-size: 48px;
    color: white;
    margin: 80px 0 32px;
  }
`;

export default FooterMainFlowerStyled;
